// frontend/src/components/common/PublicRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loader from './Loader';

interface PublicRouteProps {
  children: React.ReactElement;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, currentUser, loading } = useAuth();
  
  // Check if current path is verification-related
  const isVerificationPage = 
    children.props.path === '/verification-required' || 
    children.props.path === '/verify-email' || 
    children.props.path === '/resend-verification' || 
    window.location.pathname.includes('verification') || 
    window.location.pathname.includes('verify');
  
  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <Loader size="lg" />
      </div>
    );
  }

  // Always allow access to verification pages
  if (isVerificationPage) {
    console.log('PublicRoute: Allowing access to verification page');
    return children;
  }
  
  // For other public routes, redirect to dashboard if authenticated
  if (isAuthenticated && currentUser) {
    console.log('PublicRoute: User is authenticated, redirecting to dashboard');
    return <Navigate to="/admin" replace />;
  }

  // Not authenticated, allow access to public route
  return children;
};

export default PublicRoute;